/* @ngInject */

export default (
  $q,
  $rootScope,
  helperService,
  helperPdfService,
  quickToolService,
  dateTimeService,
  INSTANCE
) => ({
  createHomeLoanCompareProducts: ({
    compareProducts,
    reviewProducts,
    lenders,
    documents,
    fundingWorksheets,
    searchFields,
    ticket,
    isQuickTool,
    isView
  }) => {
    const deferred = $q.defer();
    const organizationCountry = helperService.getOrganizationCountry();
    const currentOrganization = $rootScope.CurrentOrganization;
    const currentAccount = $rootScope.CurrentAccount;

    const getProductSplitRow = () => ({
      colSpan: 2,
      text: '',
      style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
    });

    const prepareCompareProductDetails = ({ compareProduct, reviewProduct, splitRow, idx }) => {
      const content = getProductSplitRow();
      switch (splitRow) {
        case 'Split #':
          content.text = '';
          content.fillColor = '#eeeeee';
          break;
        case 'Loan amount':
          content.text =
            compareProduct && compareProduct.productSplits[idx]
              ? compareProduct.productSplits[idx].totalLoanAmount.formatWithCurrency(
                  $rootScope.CurrentCurrency()
                )
              : '';
          break;
        case 'Total split amount':
          content.text =
            reviewProduct && reviewProduct.productSplits[idx]
              ? reviewProduct.productSplits[idx].totalLoanAmountWithLmi.formatWithCurrency(
                  $rootScope.CurrentCurrency()
                )
              : '';
          break;
        case 'Product name':
          content.text =
            compareProduct && compareProduct.productSplits[idx]
              ? compareProduct.productSplits[idx].productName
              : '';
          break;
        case 'Interest rate':
          content.text =
            compareProduct && compareProduct.productSplits[idx]
              ? `${compareProduct.productSplits[idx].interestRate.toFixed(2)}%`
              : '';
          break;
        case 'Revert rate':
          content.text =
            compareProduct && compareProduct.productSplits[idx]
              ? `${compareProduct.productSplits[idx].revertRate.toFixed(2)}%`
              : '';
          break;
        case 'Comparison rate':
          content.text =
            compareProduct && compareProduct.productSplits[idx]
              ? `${compareProduct.productSplits[idx].comparisonRate.toFixed(2)}%`
              : '';
          break;
        case 'Monthly repayment':
          if (compareProduct && compareProduct.productSplits[idx]) {
            content.text = [
              {
                text: compareProduct.productSplits[idx].repayment1.formatWithCurrency(
                  $rootScope.CurrentCurrency()
                )
              },
              {
                text: ` ${compareProduct.productSplits[idx].repayment1Info}\n`,
                fontSize: 9
              }
            ];
            if (compareProduct.productSplits[idx].repayment2 > 0) {
              content.text.push(
                {
                  text: compareProduct.productSplits[idx].repayment2.formatWithCurrency(
                    $rootScope.CurrentCurrency()
                  )
                },
                {
                  text: ` ${compareProduct.productSplits[idx].repayment2Info}\n`,
                  fontSize: 9
                }
              );
            }
            if (compareProduct.productSplits[idx].repayment3 > 0) {
              content.text.push(
                {
                  text: compareProduct.productSplits[idx].repayment3.formatWithCurrency(
                    $rootScope.CurrentCurrency()
                  )
                },
                {
                  text: ` ${compareProduct.productSplits[idx].repayment3Info}\n`,
                  fontSize: 9
                }
              );
            }
          } else {
            content.text = '';
          }
          break;
        case 'Fees':
          content.text = '';
          content.fillColor = '#eeeeee';
          break;
        case 'Package monthly fee':
          content.text =
            reviewProduct &&
            reviewProduct.productSplits[idx] &&
            reviewProduct.productSplits[idx].fees
              ? reviewProduct.productSplits[idx].fees.packageMonthly.formatWithCurrency(
                  $rootScope.CurrentCurrency()
                )
              : '';
          break;
        case 'Package annual fee':
          content.text =
            reviewProduct &&
            reviewProduct.productSplits[idx] &&
            reviewProduct.productSplits[idx].fees
              ? reviewProduct.productSplits[idx].fees.packageAnnual.formatWithCurrency(
                  $rootScope.CurrentCurrency()
                )
              : '';
          break;
        case 'Valuation fee':
          content.text =
            reviewProduct &&
            reviewProduct.productSplits[idx] &&
            reviewProduct.productSplits[idx].fees
              ? reviewProduct.productSplits[idx].fees.valuation.formatWithCurrency(
                  $rootScope.CurrentCurrency()
                )
              : '';
          break;
        case 'Application fee':
          content.text =
            reviewProduct &&
            reviewProduct.productSplits[idx] &&
            reviewProduct.productSplits[idx].fees
              ? reviewProduct.productSplits[idx].fees.application.formatWithCurrency(
                  $rootScope.CurrentCurrency()
                )
              : '';
          break;
        case 'Rate lock fee':
          content.text =
            reviewProduct &&
            reviewProduct.productSplits[idx] &&
            reviewProduct.productSplits[idx].fees
              ? reviewProduct.productSplits[idx].fees.rateLock.formatWithCurrency(
                  $rootScope.CurrentCurrency()
                )
              : '';
          break;
        case 'Legal fee':
          content.text =
            reviewProduct &&
            reviewProduct.productSplits[idx] &&
            reviewProduct.productSplits[idx].fees
              ? reviewProduct.productSplits[idx].fees.legal.formatWithCurrency(
                  $rootScope.CurrentCurrency()
                )
              : '';
          break;
        case 'Settlement fee':
          content.text =
            reviewProduct &&
            reviewProduct.productSplits[idx] &&
            reviewProduct.productSplits[idx].fees
              ? reviewProduct.productSplits[idx].fees.settlement.formatWithCurrency(
                  $rootScope.CurrentCurrency()
                )
              : '';
          break;
        case 'Other fee':
          content.text =
            reviewProduct &&
            reviewProduct.productSplits[idx] &&
            reviewProduct.productSplits[idx].fees
              ? reviewProduct.productSplits[idx].fees.other.formatWithCurrency(
                  $rootScope.CurrentCurrency()
                )
              : '';
          break;
        case 'Features':
          content.text = '';
          content.fillColor = '#eeeeee';
          break;
        case 'Offset':
          if (reviewProduct && reviewProduct.productSplits[idx]) {
            content.text = `${
              reviewProduct.productSplits[idx]?.selectedProduct?.residential?.offset === 'YES'
                ? `Yes`
                : `No`
            }`;
            content.color = `${
              reviewProduct.productSplits[idx]?.selectedProduct?.residential?.offset === 'YES'
                ? `green`
                : `red`
            }`;
          } else {
            content.text = '';
          }
          break;
        case 'Redraw':
          if (reviewProduct && reviewProduct.productSplits[idx]) {
            content.text = `${
              reviewProduct.productSplits[idx]?.selectedProduct?.residential?.redrawFacility ===
              'YES'
                ? `Yes`
                : `No`
            }`;
            content.color = `${
              reviewProduct.productSplits[idx]?.selectedProduct?.residential?.redrawFacility ===
              'YES'
                ? `green`
                : `red`
            }`;
          } else {
            content.text = '';
          }
          break;
        case 'Additional repayments':
          if (reviewProduct && reviewProduct.productSplits[idx]) {
            content.text = `${
              reviewProduct.productSplits[idx]?.selectedProduct?.residential
                ?.additionalRepayments === 'YES'
                ? `Yes`
                : `No`
            }`;
            content.color = `${
              reviewProduct.productSplits[idx]?.selectedProduct?.residential
                ?.additionalRepayments === 'YES'
                ? `green`
                : `red`
            }`;
          } else {
            content.text = '';
          }
          break;
        case 'Split loan':
          if (reviewProduct && reviewProduct.productSplits[idx]) {
            content.text = `${
              reviewProduct.productSplits[idx]?.selectedProduct?.residential?.splitLoan ===
              'YES'
                ? `Yes`
                : `No`
            }`;
            content.color = `${
              reviewProduct.productSplits[idx]?.selectedProduct?.residential?.splitLoan ===
              'YES'
                ? `green`
                : `red`
            }`;
          } else {
            content.text = '';
          }
          break;
        default:
          break;
      }
      return content;
    };

    const getTotalLoanAmount = ({ compareProduct, reviewProduct }) => {
      let totalLoanAmount = _.reduce(
        compareProduct.productSplits,
        (memo, num) => memo + helperService.isNumber(num.totalLoanAmount, true),
        0
      );
      if (
        reviewProduct &&
        reviewProduct.productSplits[0] &&
        reviewProduct.productSplits[0].isCapitalize
      ) {
        totalLoanAmount += reviewProduct.productSplits[0].lmi;
      }
      return totalLoanAmount;
    };

    const getLenderDocument = ({ idLender }) => {
      let doc;
      if (documents.length) {
        doc = documents.find((d) =>
          d.lender[0] ? d.lender[0].id === idLender && d.type.indexOf('LOGO') > -1 : null
        );
      }
      return doc ? doc.url : '';
    };

    const getLenderLogo = ({ lenderLogos, idLender }) => {
      const logoBase64 = _.find(lenderLogos, (l) => l.id === idLender);
      return logoBase64
        ? logoBase64.logo
        : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8Xw8AAoMBgDTD2qgAAAAASUVORK5CYII=';
    };

    const getLoanTerm = () => {
      const maxArr = [];
      for (let c = 0; c < compareProducts.length; c += 1) {
        for (let d = 0; d < compareProducts[c].productSplits.length; d += 1) {
          maxArr.push(compareProducts[c].productSplits[d]);
        }
      }
      const maxLoanTerm = _.maxBy(maxArr, 'loanTerm');
      return maxLoanTerm
        ? `${
            maxLoanTerm.loanTerm === 1
              ? `${maxLoanTerm.loanTerm} year`
              : `${maxLoanTerm.loanTerm} years`
          }`
        : '0 years';
    };

    const getLenderNameOrLogo = ({ lenderLogos, idLender, isLogo }) => {
      if (isLogo) {
        return getLenderLogo({ lenderLogos, idLender });
      }
      const lender = _.find(lenders, (l) => l.id === idLender);
      return lender ? lender.name : 'N/A';
    };

    const getSplitRow = () => {
      const rows = [
        'Split #',
        'Loan amount',
        'Product name',
        'Interest rate',
        'Revert rate',
        'Comparison rate',
        'Monthly repayment',
        'Fees',
        'Package monthly fee',
        'Package annual fee',
        'Valuation fee',
        'Application fee',
        'Rate lock fee',
        'Legal fee',
        'Settlement fee',
        'Other fee',
        'Features',
        'Offset',
        'Redraw',
        'Additional repayments',
        'Split loan'
      ];

      if (organizationCountry?.cca2 === 'NZ') {
        rows.splice(2, 0, 'Total split amount');
        rows.splice(5, 1);
      }

      return rows;
    };

    const getHeaderAndSubHeaderRows = () => {
      const rows = [
        'Lender',
        'Total loan amount',
        'LVR',
        'Maximum borrowing',
        'Interest offset savings',
        'Total cashback savings',
        'Estimated costs',
        'Short term (3 years)',
        'Full term'
      ];

      if (organizationCountry?.cca2 === 'NZ') {
        rows.splice(1, 1);
      }

      return rows;
    };

    const headerAndSubHeaderRows = getHeaderAndSubHeaderRows();
    let splitRows = [];
    const maxLvr = !_.isEmpty(fundingWorksheets?.fundsAvailable)
      ? _.maxBy(fundingWorksheets?.fundsAvailable, (f) => f?.totalLvr || 0)
      : {};
    const lvr = searchFields?.lvr || maxLvr?.totalLvr || 0;
    const lenderLogos = [];
    const compareDataTableWidth = ['*'];
    const compareDataRows = [];
    const queue = [];
    compareProducts.forEach((lender) => {
      queue.push(
        $q.when(
          quickToolService
            .getBase64FromImageUrl({
              url: getLenderDocument({ idLender: lender.idLender })
            })
            .then((res) => {
              lenderLogos.push({
                id: lender.idLender,
                logo: res.data
              });
            })
        )
      );
    });
    return $q.all(queue).then(() => {
      splitRows = [];
      const headerLen = headerAndSubHeaderRows.length;
      const maxSplit = _.maxBy(compareProducts, (p) => p.productSplits.length);
      for (let s = 0; s < maxSplit.productSplits.length; s += 1) {
        splitRows = splitRows.concat(getSplitRow());
      }

      for (let i = 0; i < headerLen; i += 1) {
        const compareDataRow = [];
        compareDataRow.push({
          text:
            headerAndSubHeaderRows[i] === 'Full term'
              ? `${headerAndSubHeaderRows[i]} (${getLoanTerm()})`
              : headerAndSubHeaderRows[i],
          margin: i === 0 ? [4, 4, 0, 0] : [4, 2, 0, 2],
          fillColor:
            (i === 6 && organizationCountry?.cca2 !== 'NZ') ||
            (i === 5 && organizationCountry?.cca2 === 'NZ')
              ? '#eee'
              : '#fff',
          bold:
            (i === 6 && organizationCountry?.cca2 !== 'NZ') ||
            (i === 5 && organizationCountry?.cca2 === 'NZ'),
          style: ['tableFontSize', 'tableCellLeftAlign']
        });
        for (let j = 0; j < compareProducts.length; j += 1) {
          if (i === 0) {
            compareDataTableWidth.push(20, '*');
          }
          const compareProduct = compareProducts[j];
          const reviewProduct = reviewProducts[j];
          if (i === 0) {
            compareDataRow.push(
              {
                border: [true, true, false, true],
                width: 18,
                height: 18,
                margin: [1, 1, 1, 1],
                image: getLenderNameOrLogo({
                  lenderLogos,
                  idLender: compareProduct?.idLender,
                  isLogo: true
                }),
                style: ['tableCellCenterAlign']
              },
              {
                border: [false, true, true, true],
                text: getLenderNameOrLogo({
                  lenderLogos,
                  idLender: compareProduct?.idLender,
                  isLogo: false
                }),
                margin: [2, 4, 0, 0],
                style: ['tableFontSize', 'tableCellLeftAlign']
              }
            );
          }
          if (i === 1 && organizationCountry?.cca2 !== 'NZ') {
            const totalLoanAmount = getTotalLoanAmount({ compareProduct, reviewProduct });
            compareDataRow.push(
              {
                colSpan: 2,
                text: [
                  {
                    text: totalLoanAmount.formatWithCurrency($rootScope.CurrentCurrency())
                  },
                  {
                    text: reviewProduct.productSplits[0].isCapitalize
                      ? ' (capitalized LMI)'
                      : '',
                    fontSize: 9
                  }
                ],
                style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
              },
              ''
            );
          }
          if (
            (i === 2 && organizationCountry?.cca2 !== 'NZ') ||
            (i === 1 && organizationCountry?.cca2 === 'NZ')
          ) {
            compareDataRow.push(
              {
                colSpan: 2,
                text: `${lvr.toFixed(2)}%`,
                style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
              },
              ''
            );
          }
          if (
            (i === 3 && organizationCountry?.cca2 !== 'NZ') ||
            (i === 2 && organizationCountry?.cca2 === 'NZ')
          ) {
            compareDataRow.push(
              {
                colSpan: 2,
                text: compareProduct.productSplits[0].maximumBorrowing.formatWithCurrency(
                  $rootScope.CurrentCurrency()
                ),
                style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
              },
              ''
            );
          }
          if (
            (i === 4 && organizationCountry?.cca2 !== 'NZ') ||
            (i === 3 && organizationCountry?.cca2 === 'NZ')
          ) {
            if (compareProduct && compareProduct.costs) {
              const interestOffsetSavings = compareProduct?.costs?.interestOffsetSavings || 0;
              compareDataRow.push(
                {
                  colSpan: 2,
                  text: interestOffsetSavings.formatWithCurrency($rootScope.CurrentCurrency()),
                  style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
                },
                ''
              );
            } else {
              compareDataRow.push(
                {
                  colSpan: 2,
                  text: '',
                  style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
                },
                ''
              );
            }
          }
          if (
            (i === 5 && organizationCountry?.cca2 !== 'NZ') ||
            (i === 4 && organizationCountry?.cca2 === 'NZ')
          ) {
            if (compareProduct && compareProduct.costs) {
              const cashback = compareProduct?.costs?.cashback || 0;
              compareDataRow.push(
                {
                  colSpan: 2,
                  text: cashback.formatWithCurrency($rootScope.CurrentCurrency()),
                  style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
                },
                ''
              );
            } else {
              compareDataRow.push(
                {
                  colSpan: 2,
                  text: '',
                  style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
                },
                ''
              );
            }
          }
          if (
            (i === 6 && organizationCountry?.cca2 !== 'NZ') ||
            (i === 5 && organizationCountry?.cca2 === 'NZ')
          ) {
            compareDataRow.push(
              {
                colSpan: 2,
                text: '',
                fillColor: '#eee'
              },
              ''
            );
          }
          if (
            (i === 7 && organizationCountry?.cca2 !== 'NZ') ||
            (i === 6 && organizationCountry?.cca2 === 'NZ')
          ) {
            if (compareProduct && compareProduct.shortTotalCosts) {
              compareDataRow.push(
                {
                  colSpan: 2,
                  text: compareProduct.shortTotalCosts.formatWithCurrency(
                    $rootScope.CurrentCurrency()
                  ),
                  style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
                },
                ''
              );
            } else {
              compareDataRow.push(
                {
                  colSpan: 2,
                  text: '',
                  style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
                },
                ''
              );
            }
          }
          if (
            (i === 8 && organizationCountry?.cca2 !== 'NZ') ||
            (i === 7 && organizationCountry?.cca2 === 'NZ')
          ) {
            if (compareProduct && compareProduct.costs) {
              compareDataRow.push(
                {
                  colSpan: 2,
                  text: compareProduct.costs
                    ? compareProduct.costs.total.formatWithCurrency(
                        $rootScope.CurrentCurrency()
                      )
                    : '',
                  style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
                },
                ''
              );
            } else {
              compareDataRow.push(
                {
                  colSpan: 2,
                  text: '',
                  style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
                },
                ''
              );
            }
          }
        }
        const compareRow = _.flatten(compareDataRow);
        compareDataRows.push(compareRow);
      }

      let sIdx = 0;
      const splitRow = getSplitRow();
      let splitLen = splitRow.length;
      for (let s = 0; s < splitRows.length; s += 1) {
        if (s === splitLen) {
          splitLen += 21;
          sIdx += 1;
        }
        const compareDataRow = [];
        let fCell;
        if (splitRows[s] === 'Split #') {
          fCell = {
            text: splitRows[s] + (sIdx + 1),
            style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
          };
        } else {
          fCell = {
            text: splitRows[s],
            style: ['tableFontSize', 'tableCellLeftAlign', 'tableCellMarginLeftTopBottom']
          };
        }
        if (
          splitRows[s] === 'Split #' ||
          splitRows[s] === 'Fees' ||
          splitRows[s] === 'Features'
        ) {
          fCell.bold = true;
          fCell.fillColor = '#eeeeee';
        }
        compareDataRow.push(fCell);
        for (let c = 0; c < compareProducts.length; c += 1) {
          const compareProduct = compareProducts[c];
          const reviewProduct = reviewProducts[c];
          const row = prepareCompareProductDetails({
            compareProduct,
            reviewProduct,
            splitRow: splitRows[s],
            idx: sIdx
          });
          compareDataRow.push(row, '');
        }
        const compareRow = _.flatten(compareDataRow);
        compareDataRows.push(compareRow);
      }

      const now = moment.utc().tz($rootScope.CurrentTimeZone()).format('X');
      const date = dateTimeService.getFormattedDate(now);
      const orgLogo = currentOrganization?.organization?.logo
        ? currentOrganization.organization.logo.replace(
            /([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/gi,
            currentOrganization.id
          )
        : INSTANCE.url + INSTANCE.logo;
      quickToolService.getBase64FromImageUrl({ url: orgLogo }).then((res) => {
        const docDefinition = {
          pageSize: 'A4',
          pageOrientation: 'landscape',
          pageMargins: [40, 20, 40, 20],
          content: [
            {
              table: {
                widths: [240, '*'],
                headerRows: 1,
                body: [
                  [
                    {
                      width: 180,
                      height: 30,
                      image: res.data,
                      margin: [5, 3, 0, 3],
                      style: 'tableHeader'
                    },
                    {
                      fillColor: '#eeeeee',
                      text: `Prepared by: ${currentAccount.getName()}\nPrepared on: ${date}`,
                      style: 'prepared'
                    }
                  ]
                ]
              },
              layout: 'noBorders'
            },
            {
              text: 'Product comparison',
              style: ['header', 'marginTop']
            },
            {
              table: {
                dontBreakRows: true,
                headerRows: 1,
                widths: compareDataTableWidth,
                body: compareDataRows
              },
              style: ['marginTop'],
              layout: 'defaultLayout'
            }
          ],
          styles: {
            header: {
              fontSize: 16,
              bold: true
            },
            subHeader: {
              fontSize: 14,
              bold: true,
              margin: [0, 10, 0, 0]
            },
            prepared: {
              fontSize: 10,
              alignment: 'right',
              margin: [0, 6, 5, 0]
            },
            marginTop: {
              margin: [0, 10, 0, 0]
            },
            tableFontSize: {
              fontSize: 10
            },
            tableMarginTop: {
              margin: [0, 5, 0, 0]
            },
            tableHeader: {
              fillColor: '#eee'
            },
            tableCellMarginTop: {
              margin: [0, 2, 0, 0]
            },
            tableCellMarginLeftTopBottom: {
              margin: [4, 2, 0, 2]
            },
            tableCellMarginRightTopBottom: {
              margin: [0, 2, 4, 2]
            },
            tableCellMarginTopBottom: {
              margin: [0, 2, 0, 2]
            },
            tableCellLeftAlign: {
              alignment: 'left'
            },
            tableCellRightAlign: {
              alignment: 'right'
            },
            tableCellCenterAlign: {
              alignment: 'center'
            }
          }
        };
        pdfMake.tableLayouts = {
          defaultLayout: {
            hLineWidth(i, node) {
              return i === node.table.headerRows ? 1 : 0.5;
            },
            vLineWidth() {
              return 0.5;
            },
            hLineColor(i, node) {
              return i === 0 || i === node.table.body.length ? '#333' : '#aaa';
            },
            vLineColor(i, node) {
              return i === 0 || i === node.table.widths.length ? '#333' : '#aaa';
            },
            paddingLeft() {
              return 0;
            },
            paddingRight() {
              return 0;
            },
            paddingTop() {
              return 0;
            },
            paddingBottom() {
              return 0;
            }
          }
        };
        const fileName = `${moment.utc().year()}${moment.utc().month() + 1}${moment
          .utc()
          .date()}${isQuickTool ? ' Quick tools -' : ''} Product comparison.pdf`;
        if (isQuickTool && !_.isEmpty(docDefinition)) {
          if (!_.isEmpty(docDefinition)) {
            if (isView) {
              pdfMake.createPdf(docDefinition).open();
            } else {
              pdfMake.createPdf(docDefinition).download(fileName);
            }
            deferred.resolve();
          }
        } else if (!isQuickTool && !_.isEmpty(docDefinition)) {
          if (isView) {
            helperPdfService.viewOrSavePdf({ docDefinition, isView: true }).then(() => {
              deferred.resolve();
            });
          } else {
            helperPdfService
              .viewOrSavePdf({
                ticket,
                docDefinition,
                fileName,
                isView: false
              })
              .then(() => {
                deferred.resolve();
              });
          }
        }
      });
      return deferred.promise;
    });
  }
});
